@if (size === "l") {
<svg
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  width="32"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16 25.3334L6.66663 16.0001L16 6.66675"
    stroke="#4A2D15"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.3333 16H6.66663"
    stroke="#4A2D15"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
} @else{
<svg
  height="16"
  viewBox="0 0 32 32"
  fill="none"
  width="16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16 25.3334L6.66663 16.0001L16 6.66675"
    stroke="#1f4321"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.3333 16H6.66663"
    stroke="#1f4321"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
}
